import {NgModule} from '@angular/core';
import {TranslatePipe} from './pipes/translate.pipe';
import {KeysPipe} from './pipes/keys.pipe';
import {BsDatepickerModule, BsDropdownModule, ModalModule, PaginationModule, TabsModule} from 'ngx-bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {NgBootstrapFormValidationModule} from 'ng-bootstrap-form-validation';

@NgModule({
  imports: [
    ReactiveFormsModule,
    NgBootstrapFormValidationModule.forRoot(),
    BsDropdownModule.forRoot(),
    BsDatepickerModule.forRoot(),
    PaginationModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [
    TranslatePipe,
    KeysPipe
  ],
  exports: [
    ReactiveFormsModule,
    NgBootstrapFormValidationModule,
    TranslatePipe,
    KeysPipe,
    BsDropdownModule,
    BsDatepickerModule,
    PaginationModule,
    TabsModule
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// D:/Projects/bid/frontend/src/app/shared/shared.module.ts